import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const WindDirectionIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.9407 1.64904L19.9496 21.7572C20.0203 21.9596 20.0165 22.1791 19.9388 22.3792C19.861 22.5793 19.714 22.748 19.5222 22.8571C19.3336 22.9702 19.1104 23.0183 18.8894 22.9937C18.6684 22.9691 18.4627 22.8731 18.3064 22.7216L11.9987 16.689L5.69089 22.7206C5.5346 22.872 5.32896 22.968 5.10792 22.9927C4.88689 23.0173 4.66367 22.9691 4.47513 22.8561C4.28514 22.7455 4.13964 22.5769 4.0621 22.3775C3.98456 22.1782 3.97949 21.9596 4.04771 21.7572L11.0566 1.65008C11.102 1.507 11.1849 1.37743 11.2976 1.27369C11.3877 1.18348 11.4967 1.11252 11.6176 1.06544C11.7384 1.01836 11.8683 0.996239 11.9987 1.00052C12.2082 0.995964 12.4136 1.05693 12.5837 1.17417C12.7537 1.29141 12.8791 1.45746 12.9407 1.64904Z'
                fill='currentColor'
            />
        </>
    ),
})

WindDirectionIcon.displayName = 'WindDirectionIcon'
